const API_MASTER_DATA = process.env.BASE_API
const S3_PUBLIC_PATH = process.env.S3_PUBLIC_PATH
const AUTH_TESTING = process.env.AUTH_TESTING
const BRANCH_WEB_QUEUE_ACCESS_ID = process.env.BRANCH_WEB_QUEUE_ACCESS_ID
const QUEUE_URL = process.env.WEB_QUEUE_URL
const ADD_QUEUE_URL = process.env.ADD_QUEUE_URL

export { API_MASTER_DATA, S3_PUBLIC_PATH, AUTH_TESTING, BRANCH_WEB_QUEUE_ACCESS_ID, QUEUE_URL, ADD_QUEUE_URL }


// WEBPACK FOOTER //
// ./src/service/index.js